import './styles.scss';

export default function initScrollToTopButton() {
  const scrollToTopButton = document.querySelector('.back-to-top');

  if (!scrollToTopButton) return;

  const scrollToTopButtonElement = scrollToTopButton.querySelector('a');
  const backToTopElement = document.createElement('div');
  backToTopElement.id = 'header-scroll-to-top';
  document.body.insertBefore(backToTopElement, document.body.firstChild);

  const observerElement = backToTopElement;

  const activeClassToggle = (payload) => {
    const { isIntersecting } = payload[0];
    scrollToTopButton.classList.toggle('active', !isIntersecting);
  };

  const observer = new IntersectionObserver(activeClassToggle, {
    rootMargin: '200px',
  });

  observer.observe(observerElement);

  window.addEventListener('scroll', function () {
    let scrollPercentage =
      (window.scrollY /
        (document.documentElement.scrollHeight - window.innerHeight)) *
      100;

    let newDegrees = `${(scrollPercentage / 100) * 360}deg`;

    scrollToTopButtonElement.style.setProperty('--circle-degrees', newDegrees);
  });
}

initScrollToTopButton();
